// @ts-nocheck
import { useState, useRef, useReducer, useEffect } from 'react';
import { Dialog } from "primereact/dialog";
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { Divider } from 'primereact/divider';
import { ScrollPanel } from 'primereact/scrollpanel';
import { InputText } from 'primereact/inputtext';
import { ProjectorEntityOption } from './ProjectorInfo/ProjectorEntityOption';
import "../assets/functionalComponents/_dialog.scss"
import "../assets/functionalComponents/_dataItem.scss"
import "../assets/functionalComponents/ScrollPanelDemo.css"

const ProjectorOption = (props) => {
    const [projectorSourceList, setProjectorSourceList] = useState([]);
    const [projectorEntityList, setProjectorEntityList] = useState([]);
    const [projectorFar, setProjectorFar] = useState(150);
    const [ProjectorSet, setProjectorSet] = useState(false);
    const [indexNum, setIndexNum] = useState("");
    const [resetProjectorGeo, setResetProjectorGeo] = useState(null);
    const [latChange, setLatChange] = useState(null);
    const [lonChange, setLonChange] = useState(null);
    const [heiChange, setHeiChange] = useState(null);
    const [yawChange, setYawChange] = useState(null);
    const [pitChange, setPitChange] = useState(null);
    const [, forceUpdate] = useReducer(num => num + 1, 0);

    useEffect(() => {
        setProjectorSourceList(props.projectorSourceList);
        setProjectorEntityList(props.projectorEntityList);
    }, [props])

    const fieldListRemove = (index) => {

        let entities = projectorEntityList;
        let sources = projectorSourceList;
        let entity = projectorEntityList[index];
        let custom = window.main.OView.findLayer("custom");

        custom.removeEntity(entity.entity);
        props.toast.current.show({ severity: 'success', summary: '圖層資訊', detail: '已關閉' + entity.source });

        entities.splice(index, 1);
        sources.splice(index, 1);
        props.FieldOptionRemove(entities, sources);
        forceUpdate();
    }

    // 用以變更projector位置(經緯高度)
    const positionChange = (direction) => {

        let projector = projectorEntityList[indexNum];
        let projectorEntity = projectorEntityList[indexNum].entity;
        let param = {};
        let point = null;
        let surfaceHeight = null;
        let list = [];

        let pointX = projectorEntity.getParameter().Pos.x;
        let pointY = projectorEntity.getParameter().Pos.y;
        let pointZ = projectorEntity.getParameter().Pos.z;
        let projectorHeight = projectorEntityList[indexNum].height;

        switch (direction) {
            case "front":
                point = new window.Geo3DPoint(pointX, pointY + 0.00001, pointZ);
                surfaceHeight = window.main.OView.getAbsHeight(point, 4326);
                param.Pos = new window.Geo3DPoint(pointX, pointY + 0.00001, surfaceHeight + projectorHeight);
                break;
            case "left":
                point = new window.Geo3DPoint(pointX - 0.00001, pointY, pointZ);
                surfaceHeight = window.main.OView.getAbsHeight(point, 4326);
                param.Pos = new window.Geo3DPoint(pointX - 0.00001, pointY, surfaceHeight + projectorHeight);
                break;
            case "right":
                point = new window.Geo3DPoint(pointX + 0.00001, pointY, pointZ);
                surfaceHeight = window.main.OView.getAbsHeight(point, 4326);
                param.Pos = new window.Geo3DPoint(pointX + 0.00001, pointY, surfaceHeight + projectorHeight);
                break;
            case "back":
                point = new window.Geo3DPoint(pointX, pointY - 0.00001, pointZ);
                surfaceHeight = window.main.OView.getAbsHeight(point, 4326);
                param.Pos = new window.Geo3DPoint(pointX, pointY - 0.00001, surfaceHeight + projectorHeight);
                break;
            case "up":
                point = new window.Geo3DPoint(pointX, pointY, pointZ);
                surfaceHeight = window.main.OView.getAbsHeight(point, 4326);
                param.Pos = new window.Geo3DPoint(pointX, pointY, surfaceHeight + projectorHeight + 1);
                projector.height = projectorHeight + 1;
                break;
            case "down":
                point = new window.Geo3DPoint(pointX, pointY, pointZ);
                surfaceHeight = window.main.OView.getAbsHeight(point, 4326);
                param.Pos = new window.Geo3DPoint(pointX, pointY, surfaceHeight + projectorHeight - 1);
                projector.height = projectorHeight - 1;
                break;
            default:
                break;
        }

        projectorEntity.update(param);
        projector.entity = projectorEntity;
        list = projectorEntityList;
        list.splice(indexNum, 1, projector);
        setProjectorEntityList(list);
        forceUpdate();
    }

    // 用以變更projector視角
    const viewChange = (direction) => {

        let projector = projectorEntityList[indexNum];
        let projectorEntity = projectorEntityList[indexNum].entity;
        let projectorYaw = projectorEntityList[indexNum].yaw;
        let projectorPitch = projectorEntityList[indexNum].pitch;
        let param = {};
        let list = [];

        switch (direction) {
            case "up":
                param.Yaw = projectorYaw * Math.PI / 180;
                param.Pitch = (projectorPitch + 1) * Math.PI / 180;
                param.Roll = 0;
                projector.pitch = (360 + projectorPitch + 1) % 360;
                break;
            case "left":
                param.Yaw = (projectorYaw + 1) * Math.PI / 180;
                param.Pitch = projectorPitch * Math.PI / 180;
                param.Roll = 0;
                projector.yaw = (360 + projectorYaw + 1) % 360;
                break;
            case "right":
                param.Yaw = (projectorYaw - 1) * Math.PI / 180;
                param.Pitch = projectorPitch * Math.PI / 180;
                param.Roll = 0;
                projector.yaw = (360 + projectorYaw - 1) % 360;
                break;
            case "down":
                param.Yaw = projectorYaw * Math.PI / 180;
                param.Pitch = (projectorPitch - 1) * Math.PI / 180;
                param.Roll = 0;
                projector.pitch = (360 + projectorPitch - 1) % 360;
                break;
            default:
                break;
        }

        projectorEntity.update(param);
        projector.entity = projectorEntity;
        list = projectorEntityList;
        list.splice(indexNum, 1, projector);
        setProjectorEntityList(list);
        forceUpdate();
    }

    // 用以變更projector視距 //TODO 目前Far屬性無法及時變更於圖台上，尚待解決
    const farChange = (value) => {
        let projector = projectorEntityList[indexNum];
        let projectorEntity = projectorEntityList[indexNum].entity;
        let param = {};
        let list = [];

        param.Far = value;
        projectorEntity.update(param);

        projector.entity = projectorEntity;
        list = projectorEntityList;
        list.splice(indexNum, 1, projector);
        setProjectorEntityList(list);
        forceUpdate();
        window.main.OView.updateScreen();
    }

    // 重新點擊圖台選定projector生成位置
    const startAllOver = () => {
        window.main.OView.addEventListener("InputCompleted", projectorPosition);
        props.toast.current.show({ severity: 'info', summary: '標註資訊', detail: '請點擊滑鼠左鍵重新選擇攝影機生成地' });
        window.main.OView.inputSurfacePoint();
    }

    const projectorPosition = (event) => {
        if (event.success) {
            setResetProjectorGeo(event.geo);
            forceUpdate();
            window.main.OView.removeEventListener("InputCompleted", projectorPosition);
        }
    }

    useEffect(() => {
        if (resetProjectorGeo === null) return;

        let projector = projectorEntityList[indexNum];
        let projectorEntity = projectorEntityList[indexNum].entity;
        let param = {};
        let point = null;
        let surfaceHeight = null;
        let list = [];

        let pointX = resetProjectorGeo.x;
        let pointY = resetProjectorGeo.y;
        let pointZ = resetProjectorGeo.z;
        let projectorHeight = projectorEntityList[indexNum].height;

        point = new window.Geo3DPoint(pointX, pointY, pointZ);
        surfaceHeight = window.main.OView.getAbsHeight(point, 4326);
        param.Pos = new window.Geo3DPoint(pointX, pointY, surfaceHeight + projectorHeight);

        projectorEntity.update(param);
        projector.entity = projectorEntity;
        list = projectorEntityList;
        list.splice(indexNum, 1, projector);
        setProjectorEntityList(list);
        forceUpdate();

    }, [resetProjectorGeo])

    const changeParam = () => {

        let projector = projectorEntityList[indexNum];
        let projectorEntity = projectorEntityList[indexNum].entity;
        let param = {};
        let point = null;
        let surfaceHeight = null;
        let list = [];
        // 判斷InputBox是否有輸入資料，若無則使用原參數資料
        let lon = lonChange ? parseFloat(lonChange) : projector.entity.getParameter().Pos.x;
        let lat = latChange ? parseFloat(latChange) : projector.entity.getParameter().Pos.y;
        let hei = heiChange ? parseFloat(heiChange) : projector.height;
        let yaw = yawChange ? parseFloat(yawChange) : projector.yaw;
        let pit = pitChange ? parseFloat(pitChange) : projector.pitch;

        point = new window.Geo3DPoint(lon, lat, hei);
        surfaceHeight = window.main.OView.getAbsHeight(point, 4326);
        param.Pos = new window.Geo3DPoint(lon, lat, surfaceHeight + hei);
        // Yaw角、Pitch角、Roll角需經過座標轉換
        param.Yaw = (360 - (yaw % 360)) * Math.PI / 180;
        param.Pitch = pit * Math.PI / 180;
        param.Roll = 0;
        // 儲存變更後參數資料
        projector.height = hei;
        projector.yaw = (360 + yaw) % 360;
        projector.pitch = (360 + pit) % 360;
        projectorEntity.update(param);

        projector.entity = projectorEntity;
        list = projectorEntityList;
        // 將變更後資訊存入原始資料位置
        list.splice(indexNum, 1, projector);
        setProjectorEntityList(list);
        forceUpdate();
    }

    return (
        <div>
            {
                projectorEntityList.map((item, index) => {
                    return (
                        <div>
                            <div className="field-item">
                                <div className="field-detail">{item.source.name ? item.source.name : item.source}</div>
                                <div className="field-action">
                                    {
                                        item.entity.show === true ?
                                            <Button icon="pi pi-eye-slash" className="p-button-rounded p-button-info field-button" onClick={() => { item.entity.show = false; forceUpdate() }} /> :
                                            <Button icon="pi pi-eye" className="p-button-rounded p-button-info field-button" onClick={() => { item.entity.show = true; forceUpdate() }} />

                                    }
                                    <Button icon="pi pi-map-marker" className="p-button-rounded field-button" onClick={() => { item.entity.goto() }} />
                                    <Button icon="pi pi-cog" className="p-button-rounded p-button-warning field-button" onClick={() => { setProjectorSet(true); setIndexNum(index) }} />
                                    <Button icon="pi pi-times" className="p-button-rounded p-button-danger field-button" onClick={() => { fieldListRemove(index) }} />
                                </div>
                            </div>
                            <Divider />
                        </div>
                    )
                })
            }
            <div className="layout-main-container">
                <ProjectorEntityOption ProjectorSet={ProjectorSet} setProjectorSet={setProjectorSet} projectorEntityList={projectorEntityList} indexNum={indexNum} positionChange={positionChange} viewChange={viewChange}
                    projectorFar={projectorFar} setProjectorFar={setProjectorFar} farChange={farChange} startAllOver={startAllOver} setLatChange={setLatChange} setLonChange={setLonChange} setHeiChange={setHeiChange}
                    changeParam={changeParam} setYawChange={setYawChange} setPitChange={setPitChange} />
            </div>
        </div>
    )
}

export const ProjectorComponents = (props) => {
    const ref = useRef();
    const toast = useRef(null);

    const [, forceUpdate] = useReducer(num => num + 1, 0);
    const [plusProjector, setPlusProjector] = useState(false);
    const [projectorGeo, setProjectorGeo] = useState(null);
    const [projectorSourceList, setProjectorSourceList] = useState([]);
    const [projectorEntityList, setProjectorEntityList] = useState([]);
    const [VideoPath, setVideoPath] = useState(null);

    // 取得影片網址來源
    const sendVideoPath = () => {

        if (VideoPath === null) {
            toast.current.show({ severity: 'warn', summary: '提醒資訊', detail: '未提供影片網址，請輸入影片網址!' });
            return;
        }
        let list = [];
        list = projectorSourceList;
        list.push(VideoPath);
        setProjectorSourceList(list);
        setPlusProjector(false);
        forceUpdate();
    }

    useEffect(() => {
        if (projectorGeo === null) return;
        setVideoPath(null);
        setPlusProjector(true);
        toast.current.show({ severity: 'success', summary: '提醒資訊', detail: '座標選擇完成，接著請選擇欲播放檔案或影片網址!' });
        forceUpdate();
    }, [projectorGeo])

    useEffect(() => {

        if (projectorSourceList.length > projectorEntityList.length) {

            let param = {};
            let list = [];
            let custom = null;
            let projectorEntity = null;
            // 取得滑鼠點擊對應座標並取得地形高度，避免projector出現在地形之下
            let point = new window.Geo3DPoint(projectorGeo.x, projectorGeo.y, projectorGeo.z);
            let surfaceHeight = window.main.OView.getAbsHeight(point, 4326);

            custom = window.main.OView.findLayer("custom");

            if (custom === null) {
                custom = window.main.OView.addCustomLayer({
                    layername: "custom"
                });
            }

            // TODO 後續若要增建非mjpeg檔則需考慮VideoPath及SrcType
            projectorEntity = custom.addProjectorEntity({
                Pos: new window.Geo3DPoint(projectorGeo.x, projectorGeo.y, surfaceHeight + 1),
                V: new window.Geo3DPoint(0, 1, 0),
                Up: new window.Geo3DPoint(0, 0, 1),
                Far: 150,
                VideoPath: projectorSourceList[projectorSourceList.length - 1],
                EnableFade: false,
                // 若影片格式為mjpeg則SrcType為IMAGE，若為VIDEO則SrcType為VIDEO
                SrcType: ov.PROJECTOR_SRC.IMAGE
            });

            projectorEntity.show = true;
            projectorEntity.goto();

            // 儲存所需參數以便後續變更
            param.source = projectorSourceList[projectorSourceList.length - 1];
            param.entity = projectorEntity;
            param.yaw = 0;
            param.pitch = 0;
            param.height = 1;

            list = projectorEntityList;
            list.push(param);
            setProjectorEntityList(list);

            forceUpdate();
        }

    }, [projectorSourceList.length])

    const addProjector = () => {
        window.main.OView.addEventListener("InputCompleted", projectorPosition);
        toast.current.show({ severity: 'info', summary: '標註資訊', detail: '請點擊滑鼠左鍵選擇攝影機生成地' });
        window.main.OView.inputSurfacePoint();
    }

    const projectorPosition = (event) => {
        if (event.success) {
            setProjectorGeo(event.geo);
            forceUpdate();
            window.main.OView.removeEventListener("InputCompleted", projectorPosition);
        }
    }

    const FieldOptionRemove = (layers, sources) => {
        setProjectorSourceList(sources);
        setProjectorEntityList(layers);
        forceUpdate();
    }


    return (
        <div>
            <Toast ref={toast} />
            <Dialog header="虛實整合攝影機" visible={props.Projector} modal={false} keepInViewport={false} onHide={() => props.onHide('Projector')}>
                <Card>
                    <div className="field-item" style={{ width: '95%' }}>
                        <div className="field-object">項目</div>
                        <div className="field-object">功能</div>
                    </div>
                    <Divider />
                    <div className="scrollpanel-demo">
                        <ScrollPanel style={{ width: '100%', height: '350px' }} className="custombar1">
                            <ProjectorOption projectorEntityList={projectorEntityList} setProjectorEntityList={setProjectorEntityList} projectorSourceList={projectorSourceList} setProjectorSourceList={setProjectorSourceList} FieldOptionRemove={FieldOptionRemove} toast={toast} />
                        </ScrollPanel>
                    </div>
                </Card>
                <br></br>
                {
                    plusProjector === false ?
                        (
                            <Card>
                                <div className="field grid">
                                    <div className="col-12 md:col-12">
                                        <Button label="新增攝影機" icon="pi pi-plus" className="p-button-raised" onClick={() => { addProjector() }} style={{ width: "100%" }} />
                                    </div>
                                </div>
                            </Card>
                        ) :
                        (
                            <Card subTitle='虛實整合影像來源'>
                                <div className="field grid">
                                    <div className="col-12 md:col-8">
                                        <InputText onChange={(e) => setVideoPath(e.target.value)} style={{ width: "100%" }} />
                                    </div>
                                    <div className="col-12 md:col-4">
                                        <Button label="輸入網址" icon="pi pi-plus" className="p-button-raised" onClick={() => { sendVideoPath() }} style={{ width: "100%", height: "100%" }} />
                                    </div>
                                </div>
                            </Card>
                        )
                }
            </Dialog>
        </div>
    )
}